module.exports = __webpack_public_path__ + "img/teamine_1.c275f83e.png";